import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../assets/style/base.global.scss'
import '../assets/style/public.global.scss'

Vue.use(ElementUI)
Vue.prototype.$message = ElementUI.Message;
Vue.prototype.$loading = ElementUI.Loading;
window.gdzjAreaCode = "4408"; //湛江地区行政编码
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
